import { API_ROUTES, useApiService } from '@shared/api-utils';
import { useCallback } from 'react';

type SignOutOptions = {
  callbackUrl?: string;
  redirect?: boolean;
  logoutRedirectUri?: string;
};
type SignOutFn = (options?: SignOutOptions) => Promise<void>;

function useSignOut(): SignOutFn {
  const apiService = useApiService();

  return useCallback(
    async (options?: SignOutOptions) => {
      const { callbackUrl = '/', redirect = true, logoutRedirectUri = '' } = options || {};

      try {
        await apiService.post(
          API_ROUTES.MY_ACCOUNT.PLAYER_AUTH.LOGOUT,
          { logoutRedirectUri },
          {
            credentials: 'include',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          }
        );

        if (redirect) {
          const successUrl = new URL(logoutRedirectUri === '' ? '/' : logoutRedirectUri, window.location.href);
          successUrl.searchParams.set('logout_success', 'true');
          window.location.href = successUrl.toString();
        }
      } catch {
        if (redirect) {
          window.location.href = callbackUrl;
        }
      }
    },
    [apiService]
  );
}

export { useSignOut };
